// GLOBAL CSS
import './src/static/css/defaults.css'
import "@fontsource/montserrat/latin.css"

import React from 'react'
import { Provider } from './src/provider'


export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>
